import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import { MAX_COMPARISON_SELECTIONS } from 'constants/offer'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { addCartOfferComparisonSelection, removeCartOfferComparisonSelection } from 'actions/CartOfferComparisonActions'
import { stopPropagation } from 'lib/web/eventHandlerUtils'
import { rem } from 'polished'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import Tooltip from 'LuxKit/Tooltip'
import { selectCartOfferComparisonSpoofedSelections } from 'selectors/cartOfferComparisonSelectors'
import { isSpoofed } from 'selectors/featuresSelectors'

const Root = styled.div`
  display: inline-block;
  padding-bottom: ${rem(12)};
`

interface Props {
  cartItemId: string
  offerType: App.OfferType
  offerId: string
  name: string
  roomId?: string
  packageUniqueKey?: string
  filters?: App.OfferListFilters
  priceTotals?: {
    price: number
    memberPrice: number
    value: number
  }
}

function AccommodationTileComparisonCheckbox({
  packageUniqueKey,
  offerType,
  offerId,
  name,
  filters,
  roomId,
  priceTotals,
  cartItemId
}: Props) {
  const dispatch = useAppDispatch()
  const currentSelections = useAppSelector(selectCartOfferComparisonSpoofedSelections)
  const canAddSelection = currentSelections.length < MAX_COMPARISON_SELECTIONS
  const isSpoofedEnabled = useAppSelector(isSpoofed)

  const [selectionId] = useState(cartItemId)

  const currentSelection = currentSelections.find(s => s.selectionId === cartItemId)
  const isSelected = !!currentSelection

  const onToggle = useCallback(() => {
    if (currentSelection) {
      dispatch(removeCartOfferComparisonSelection(currentSelection.selectionId))
    } else {
      dispatch(addCartOfferComparisonSelection({ selectionId, offerType, offerId, name, priceTotals, params: { packageUniqueKey, roomId, filters } }))
    }
  }, [currentSelection, dispatch, selectionId, offerType, offerId, name, roomId, filters, priceTotals, packageUniqueKey])

  const checkboxDisabled = !isSelected && !canAddSelection

  if (!isSpoofedEnabled) {
    return null
  }

  return (
    <Tooltip description={`Only ${MAX_COMPARISON_SELECTIONS} offers can be compared at a time`} disabled={!checkboxDisabled}>
      <Root onClick={stopPropagation}>
        <CheckboxInput
          onChange={onToggle}
          disabled={checkboxDisabled}
          checked={isSelected}
        >
          Compare
        </CheckboxInput>
      </Root>
    </Tooltip>
  )
}

export default AccommodationTileComparisonCheckbox
